// =======Preloader js===============
(() => {
const p = document.querySelector(".preloader-ctt");
if (p !== null){
setTimeout(() => {
    p.classList.add("is-active");
}, 30);
setTimeout(() => {
    const e = document.querySelector(".slideshow:not(.preloaded)");
    if (e) {
        new MutationObserver((mutations) => {
            if (
                mutations[0].attributeName === "class" &&
                e.classList.contains("preloaded")
            ) {
                p.classList.add("is-fadeout");
            }
        }).observe(e, { attributes: true });
        setTimeout(() => {
            p.classList.add("is-fadeout");
        }, 2000); // maximum waiting time
    } else {
        p.classList.add("is-fadeout");
    }
    p.addEventListener("transitionend", (e) => {
        e.stopPropagation();
        p.remove();
    });
}, 2000);
}
})();

// =======back to top button js===============
(function() {
    function trackScroll() {
        var scrolled = window.pageYOffset;
        var coords = 300;

        if (scrolled > coords) {
        goTopBtn.classList.remove('hide');
        }
        if (scrolled < coords) {
        goTopBtn.classList.add('hide');
        }
    } 
    function backToTop() {
        if (window.pageYOffset > 0) {
        window.scrollBy(0, -80);
        //setTimeout(backToTop, 0);
      return window.scrollTo({behavior: 'smooth'});
        }
    } 
    var goTopBtn = document.querySelector('.back-to-top');

    window.addEventListener('scroll', trackScroll);
    goTopBtn.addEventListener('click', backToTop);
    })();

jQuery(function($) {
  var path = window.location.href; 
  $('.header__primary-nav-item a').each(function() {
    if (this.href == path) {
      $(".header__primary-nav-item:first-child").addClass('active');
      $(this).parent().addClass('active').siblings().removeClass('active');
    }
  });
  AOS.init({
  duration: 1500
});
});





  // $(document).ready(function(){
  //   $('.column-crafting-stories').slick({
  //   slidesToShow: 3.5,
  //   dots:true,
  //   centerMode: false,
  //   arrows:false,
  //   infinite: false,
  //   draggable: true, 
  //   swipe: true, 
  //   responsive: [
  //         {
  //         breakpoint: 1100,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 2,
  //           infinite: true,
  //           dots: true
  //         }
  //       },
  //       {
  //         breakpoint: 600,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 2
  //         }
  //       },
  //       {
  //         breakpoint: 480,
  //         settings: {
  //           slidesToShow: 1,
  //           slidesToScroll: 1,
  //            centerMode: false
  //         }
  //       }
  //     ]
  //   });

  //   var swiper = new Swiper(".column-crafting-stories", {
  //     cssMode: true,
  //     speed: 1000,
  //     navigation: {
  //       nextEl: ".swiper-button-next",
  //       prevEl: ".swiper-button-prev"
  //     },
  //     //wrapperClass: "snapslider-scroll",
  //     //slideClass: "snapslider-card",
  //     slidesPerView: "auto",
  //     mousewheel: true,
  //     keyboard: true,
  //   });
    
  // });



          




// Slider js
 var $slider = jQuery(".slider-product");

    if ($slider.length) {
      let currentSlide;
      let slidesCount;
      let sliderCounter = document.createElement("div");
      
      $slider.slick({
        dots: false,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnFocus: false,
        pauseOnHover: false,
        arrows: true,
        cssEase: "linear",
        variableWidth: true
      });

      function progress(sliders) {
        sliders.each(function () {
          var slider = jQuery(this);
          var $progressBar = slider
            .parentsUntil(".variable_slider_row")
            .find(".progress-2");

          slider.on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
              var calc = ((nextSlide + 1) / slick.slideCount) * 100;
              $progressBar.css("background-size", calc + "% 100%");
            }
          );
        });
      }

      progress($slider);
    }



// Simple slider


var $slider = jQuery(".slider");

  if ($slider.length) {
    let currentSlide;
    let slidesCount;
    let sliderCounter = document.createElement("div");

    $slider.slick({
      dots: false,
      autoplay: false,
      autoplaySpeed: 3000,
      pauseOnFocus: false,
      pauseOnHover: false,
      arrows: true,
      cssEase: "linear",
      variableWidth: true
    });
    
    function progress(sliders) {
      sliders.each(function () {
        var slider = jQuery(this);
        var $progressBar = slider
          .parentsUntil(".variable_slider_row")
          .find(".progress");

        slider.on(
          "beforeChange",
          function (event, slick, currentSlide, nextSlide) {
            var calc = ((nextSlide + 1) / slick.slideCount) * 100;
            $progressBar.css("background-size", calc + "% 100%");
          }
        );
      });
    }

    progress($slider);
  }

  $(document).ready(function () {

    var highestBox = 0;
    $('.bannift-body p').each(function () {
      if ($(this).height() > highestBox) {
        highestBox = $(this).height();
      }
    });
    $('.bannift-body p').height(highestBox);
    $('.pick_user_image').on('click', function() {
        const imageUrl = $(this).data('image');
        const mobileImageUrl = $(this).data('mobile-image');
        
        const isMobileView = window.matchMedia("(max-width: 768px)").matches;
        const selectedImageUrl = isMobileView ? mobileImageUrl : imageUrl;
        $('.pick_user_image').removeClass('active');
        $(this).addClass('active');
        $('.World-Renowned-Partners').css('background-image', `url(${selectedImageUrl})`);
    });
  });




$(document).ready(function(){
    $(document).on('click','.block-swatch', function() {
        var variantId = $(this).data('option-value');
        var productReservePrice = $(this).data('reserve-price');
        var productPrice = $(this).data('product-price');
        var variantReserve = $(this).data('variant-reserve');
        var productTitle = $(this).data('product-title');
        if(productReservePrice.trim() != ""){
          $('.varient_price').html(productReservePrice);
        }
        if(productPrice.trim() != ""){
          $('sale-price').html(productPrice);
        }
        if(productTitle.trim() != ""){
          $('[data-block-type="title"] .product-title').html(productTitle);
        }
        if(variantReserve){
          $('.reserve-button').attr('data-variant',variantReserve);
        }
        $('.meta_field_incudes').hide();
        $('.meta_field_incuded_' + variantId).show();
    });

    $('[data-option-selector] input:checked').next('label').trigger('click');

    var highestBox = 0;
        $('.product-slider-card h2').each(function(){  
                if($(this).height() > highestBox){  
                highestBox = $(this).height();  
        }
    });    
    $('.product-slider-card h2').height(highestBox);
});

$(document).ready(function(){
    var $slider = $('.slider-product');
    var $counter = $('.slide-counter');
    
    $slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        var i = (currentSlide ? currentSlide : 0) + 1;
        $counter.text(i + '/' + slick.slideCount);
    });
});

//Product page New slider script
// $(document).ready(function(){
//   var $slider = $('.slider-product-new');
//   var $counter = $('.slide-counter');

//   $slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
//     var i = (currentSlide ? currentSlide : 0) + 1;
//     $counter.text(i + '/' + slick.slideCount);
//   });

//   $slider.slick({
//     arrows: true,
//     infinite: true,
//     dots: false,
//     slidesToShow: 2,
//     centerMode: true,
//     centerPadding: '40px',
//     prevArrow: '<div class="custom-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0586/6972/7798/files/Arrow_2.svg?v=1724781649" alt="left-arrow"></div>',
//     nextArrow: '<div class="custom-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0586/6972/7798/files/Arrow_1_1.svg?v=1724781597" alt="right-arrow"></div>',
//     responsive: [
//       {
//         breakpoint: 1024, // screen width 1024px and below
//         settings: {
//           slidesToShow: 2,
//           centerPadding: '20px'
//         }
//       },
//       {
//         breakpoint: 768, // screen width 768px and below
//         settings: {
//           slidesToShow: 1,
//           centerPadding: '30px'
//         }
//       },
//       {
//         breakpoint: 480, // screen width 480px and below
//         settings: {
//           slidesToShow: 1,
//           centerMode: false, // Disable center mode for small screens
//           centerPadding: '0px'
//         }
//       }
//     ]
//   });
// });

// 23/09/2024 


// $(document).ready(function(){
//   var $slider = $('.slider-product-new');
//   var $counter = $('.slide-counter');

//   // Check the window width
//   if ($(window).width() > 767) {
//     // Initialize slick slider only for screen widths greater than 767px
//     $slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
//       var i = (currentSlide ? currentSlide : 0) + 1;
//       $counter.text(i + '/' + slick.slideCount);
//     });

//     $slider.slick({
//       arrows: true,
//       infinite: true,
//       dots: false,
//       slidesToShow: 2,
//       centerMode: true,
//       centerPadding: '40px',
//       prevArrow: '<div class="custom-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0586/6972/7798/files/Arrow_2.svg?v=1724781649" alt="left-arrow"></div>',
//       nextArrow: '<div class="custom-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0586/6972/7798/files/Arrow_1_1.svg?v=1724781597" alt="right-arrow"></div>',
//       responsive: [
//         {
//           breakpoint: 1024, // screen width 1024px and below
//           settings: {
//             slidesToShow: 2,
//             centerPadding: '20px'
//           }
//         },
//         {
//           breakpoint: 768, // screen width 768px and below
//           settings: {
//             slidesToShow: 1,
//             centerPadding: '30px'
//           }
//         },
//         {
//           breakpoint: 480, // screen width 480px and below
//           settings: {
//             slidesToShow: 1,
//             centerMode: false, // Disable center mode for small screens
//             centerPadding: '0px'
//           }
//         }
//       ]
//     });
//   }
// });
$(document).ready(function() {
  var $sliderFor = $('.slider-for');
  var $sliderProductNew = $('.slider-product-new');
  var $listedTestimonials = $('.listedTestimonials'); 
  var $listedAppSlider = $('.listedAppSlider'); 
  var $listedAthletesReviews = $('.listedAthletesReviews');
  var $listedAppProductSlider = $('.listedAppProductSlider');
  var $listedAilmentSection = $('.listedAilmentSection');
  var $listedAilmentSectionV2 = $('.listedAilmentSectionV2');
  var $listedYoutubeVideos = $('.listedYoutubeVideos');
  var $ailmentCounter = $('.ailmentCounter');
  var $ailmentCounter2 = $('.ailmentCounter2');
  var $counter = $('.slide-counter');
  var $appCounter = $('.appCounter');
  var slickInitialized = false;
  var userInteracted = false; // Track if user has interacted with the slider
  var userAppInteracted = false;

  // Function to initialize slick only when window width is above 767px
  function initializeSlick() {
    var mediaQuery = window.matchMedia('(min-width: 768px)');

    if (mediaQuery.matches) { // If the window width is at least 768px
      if (!slickInitialized && $sliderFor.length > 0) {
        // Initialize the main text slider
        $sliderFor.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.slider-product-new',
          adaptiveHeight: true
        });

        // Initialize the image slider
        $sliderProductNew.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          asNavFor: '.slider-for',
          prevArrow: '<div class="custom-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0586/6972/7798/files/Arrow_2.svg?v=1724781649" alt="left-arrow"></div>',
          nextArrow: '<div class="custom-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0586/6972/7798/files/Arrow_1_1.svg?v=1724781597" alt="right-arrow"></div>',
          responsive: [
            {
              breakpoint: 1024, // For screens smaller than 1024px
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                arrows: true
              }
            },
            {
              breakpoint: 768, // For screens smaller than 768px
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true
              }
            },
            {
              breakpoint: 480, // For screens smaller than 480px
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: false // You can disable arrows for mobile if needed
              }
            }
          ]
        });

        // Update counter on slider change after user interaction
        $sliderProductNew.on('afterChange', function(event, slick, currentSlide) {
          if (userInteracted) {
            var currentSlideIndex = (typeof currentSlide === 'undefined') ? 0 : currentSlide; // Default to 0 if undefined
            var slideNumber = currentSlideIndex + 1; // Increment to match a 1-based count

            // Update counter text
            $counter.text(slideNumber + '/' + slick.slideCount);
          }
        });

        // Listen for user interaction to enable the counter update
        $sliderProductNew.on('click', '.custom-arrow', function() {
          userInteracted = true;
        });

        slickInitialized = true;
      }
    } else { 
      // If the window width is less than 768px
      if (slickInitialized) {
        // Destroy slick if it's initialized
        $sliderFor.slick('unslick');
        $sliderProductNew.slick('unslick');
        slickInitialized = false;
      }
    }
  }

  // Run on page load
  initializeSlick();

  // Reinitialize on window resize
  $(window).resize(function() {
    initializeSlick();
  });



  if($listedTestimonials.length > 0){
    $listedTestimonials.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true,
      centerMode: true,   
      prevArrow: '<div class="brand-slick-arrow prev-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>',
      nextArrow: '<div class="brand-slick-arrow next-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>',
      responsive: [
        {
          breakpoint: 768, // For screens smaller than 768px
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480, // For screens smaller than 480px
          settings: {
            slidesToShow: 1
          }
        }       
      ]
    });
  }

  if($listedAppSlider.length > 0){
    $listedAppSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true,  
      prevArrow: '<div class="app-arrow brand-slick-arrow prev-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>',
      nextArrow: '<div class="app-arrow brand-slick-arrow next-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>'   
    });
  }

  if($listedAthletesReviews.length > 0){
    $listedAthletesReviews.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true,
      prevArrow: '<div class="app-arrow brand-slick-arrow prev-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>',
      nextArrow: '<div class="app-arrow brand-slick-arrow next-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>'            
    }); 
  }

  if($listedAppProductSlider.length > 0){
    $listedAppProductSlider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true,
      prevArrow: '<div class="app-arrow brand-slick-arrow prev-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>',
      nextArrow: '<div class="app-arrow brand-slick-arrow next-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>',
      responsive: [
        {
          breakpoint: 1199, // For screens smaller than 767px
          settings: {
            slidesToShow: 1
          }
        }       
      ]       
    });  
  }

  if($listedAilmentSection.length > 0){
    $listedAilmentSection.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true,
      variableWidth: true,
      centerMode: true,
      prevArrow: '<div class="app-arrow brand-slick-arrow prev-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>',
      nextArrow: '<div class="app-arrow brand-slick-arrow next-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>',
      responsive: [
        {
          breakpoint: 991, // For screens smaller than 991px
          settings: {
            slidesToShow: 1
          }
        },       
      ]      
    }); 
  } 


  function initSlick() {
    if ($(window).width() < 767) {  // Mobile breakpoint
      if (!$('.listedAilmentSectionV2').hasClass('slick-initialized')) {
        $('.listedAilmentSectionV2').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,    
          prevArrow: '<div class="app-arrow brand-slick-arrow prev-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>',
          nextArrow: '<div class="app-arrow brand-slick-arrow next-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>'
        });
      }
    } else {
      if ($('.listedAilmentSectionV2').hasClass('slick-initialized')) {
        $('.listedAilmentSectionV2').slick('unslick'); // Destroy Slick on desktop
      }
    }
  }

    initSlick(); // Run on page load

    $(window).resize(function() {
      initSlick(); // Run on window resize
    });  

  // if($listedAilmentSectionV2.length > 0){
  //   $listedAilmentSectionV2.slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     infinite: true,
  //     dots: false,
  //     arrows: true,
  //     mobileFirst: true,     
  //     prevArrow: '<div class="app-arrow brand-slick-arrow prev-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>',
  //     nextArrow: '<div class="app-arrow brand-slick-arrow next-arrow d-flex align-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 8C22 8.46024 21.6482 8.83333 21.2143 8.83333L2.6826 8.83333L7.62701 14.0774C7.93385 14.4028 7.93385 14.9305 7.62701 15.2559C7.32017 15.5814 6.82268 15.5814 6.51584 15.2559L0.230132 8.58926C-0.0767094 8.26382 -0.0767094 7.73618 0.230131 7.41074L6.51584 0.744078C6.82268 0.418641 7.32017 0.418641 7.62701 0.744078C7.93385 1.06952 7.93385 1.59715 7.62701 1.92259L2.6826 7.16667L21.2143 7.16667C21.6482 7.16667 22 7.53976 22 8Z" fill="white"/></svg></div>',    
  //     responsive: [
  //       {
  //         breakpoint: 991, // For screens smaller than 991px
  //         settings: {
  //           slidesToShow: 1
  //         }
  //       }       
  //     ]       
  //   }); 
  // }  

  if($listedYoutubeVideos.length > 0){
    $listedYoutubeVideos.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1199, // For screens smaller than 991px
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767, // For screens smaller than 991px
          settings: {
            slidesToShow: 2
          }
        }        
      ]      
    }); 
  }  

  

  

    // Update counter on slider change after user interaction
    $listedAilmentSection.on('afterChange', function(event, slick, currentSlide) {
      if (userAppInteracted) {
        var currentSlideIndex = (typeof currentSlide === 'undefined') ? 0 : currentSlide; // Default to 0 if undefined
        var slideNumber = currentSlideIndex + 1; // Increment to match a 1-based count

        // Update counter text
        $ailmentCounter.text(slideNumber + '/' + slick.slideCount);
      }
    }); 

    // Update counter on slider change after user interaction
    $listedAilmentSectionV2.on('afterChange', function(event, slick, currentSlide) {
      if (userAppInteracted) {
        var currentSlideIndex = (typeof currentSlide === 'undefined') ? 0 : currentSlide; // Default to 0 if undefined
        var slideNumber = currentSlideIndex + 1; // Increment to match a 1-based count

        // Update counter text
        $ailmentCounter2.text(slideNumber + '/' + slick.slideCount);
      }
    });   

  
    // Update counter on slider change after user interaction
    $listedAppSlider.on('afterChange', function(event, slick, currentSlide) {
      if (userAppInteracted) {
        var currentSlideIndex = (typeof currentSlide === 'undefined') ? 0 : currentSlide; // Default to 0 if undefined
        var slideNumber = currentSlideIndex + 1; // Increment to match a 1-based count

        // Update counter text
        $appCounter.text(slideNumber + '/' + slick.slideCount);
      }
    });

    // Update counter on slider change after user interaction
    $listedAppProductSlider.on('afterChange', function(event, slick, currentSlide) {
      if (userAppInteracted) {
        var currentSlideIndex = (typeof currentSlide === 'undefined') ? 0 : currentSlide; // Default to 0 if undefined
        var slideNumber = currentSlideIndex + 1; // Increment to match a 1-based count

        // Update counter text
        $appCounter.text(slideNumber + '/' + slick.slideCount);
      }
    });  


    // Listen for user interaction to enable the counter update
    $listedAppSlider.on('click', '.app-arrow', function() {
      userAppInteracted = true;
    });  
    // Listen for user interaction to enable the counter update
    $listedAppProductSlider.on('click', '.app-arrow', function() {
      userAppInteracted = true;
    }); 

    $listedAilmentSection.on('click', '.app-arrow', function() {
      userAppInteracted = true;
    }); 

    $listedAilmentSectionV2.on('click', '.app-arrow', function() {
      userAppInteracted = true;
    });   
  
  

  
});

$(document).ready(function(){
    $('.contact-cta .button').on('click', function(){
        openPopup('#team-popup');
    });
});

document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  //console.log("Variant Details =>", variant);
  // console.log("Variant Title =>", variant.title);
  let selected_variant = document.querySelector('.current_selected_variant');  
  // Check if the element exists
  if (selected_variant) {
    // Add the desired text to the element
    selected_variant.textContent = variant.title;
  }  

  const checkedRadio = document.querySelector('.radio_swatch:checked');

  // Select the <p> element to update
  const shippingTimeElement = document.querySelector('.item_shipping_time');

  if (checkedRadio) {
    // Get the corresponding label using the `for` attribute
    const label = document.querySelector(`label[for="${checkedRadio.id}"]`);

    if (label) {
      // Get the data attribute value
      const shippingTime = label.dataset.time;

      // Update the <p> element or clear it if the value is empty
      shippingTimeElement.textContent = shippingTime || '';
    } else {
      // Clear the <p> element if no label is found
      shippingTimeElement.textContent = '';
    }
  } else {
    // Clear the <p> element if no radio button is selected
    shippingTimeElement.textContent = '';
  }

  
});